import React from "react";
import { useTranslation } from "react-i18next";
import { Trash } from "lucide-react";
import ActionPopup from "@/components/common/ActionPopup";

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  title: string;
  description: string;
  isDeleting?: boolean;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  isDeleting = false
}) => {
  const { t } = useTranslation();

  return (
    <ActionPopup
      isOpen={isOpen}
      icon={<Trash className="h-5 w-5" />}
      iconTone="danger"
      title={title}
      description={description}
      cancelLabel={t("common.cancel")}
      confirmLabel={t("common.delete")}
      confirmTone="danger"
      loading={isDeleting}
      loadingLabel={t("common.deleting")}
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DeleteConfirmationDialog; 